import * as types from "./types";

export const consultarCodigoGTM = () => ({
    type: types.CONSULTAR_CODIGO_GTM
});

export const codigoGTMConsultado = (codigo) => ({
    codigo,
    type: types.CODIGO_GTM_CONSULTADO
});
